module.exports = __webpack_public_path__ + "img/auth.d7661397.png";